/** The invisible one-login standard (founder ruling 2026-08-04).
 *
 *  Conclave has NO login UI. Unauthenticated visitors are silently sent to the
 *  gate's /login with ?next=<where they were headed>; the gate signs them in
 *  (or just bounces, if its session is live) and returns them to that exact
 *  URL — the shared .diwata.domains Warden cookie does the rest. Sign-out is
 *  the gate's /logout, which ends the suite-wide session.
 *
 *  The gate origin always arrives from the backend's /auth/gate/status (the
 *  single GATE_PUBLIC_ORIGIN config) — never hardcode a gate host here.
 */

export function gateLoginUrl(gateOrigin: string, currentHref: string): string {
  const url = new URL('/login', gateOrigin)
  url.searchParams.set('next', currentHref)
  return url.toString()
}

export function gateLogoutUrl(gateOrigin: string, next?: string): string {
  const url = new URL('/logout', gateOrigin)
  // Carry the app's origin so the gate's sign-in keeps this app's brand plate
  // (and a fresh sign-in returns here) instead of the generic page.
  if (next) url.searchParams.set('next', next)
  return url.toString()
}
